import { defaultBorrowerLegalName } from '../../components/loan_application/form_models/constants';
import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { borrowerWasBusinessAcquired },
} = loanFormModel;

export class BorrowerWasBusinessAcquiredValidation implements ValidationSchema {
  public name: string = borrowerWasBusinessAcquired.name;
  public label: string = borrowerWasBusinessAcquired.getLabel(
    defaultBorrowerLegalName
  );
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
}

export default new Validation(new BorrowerWasBusinessAcquiredValidation());
